.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: var(--space-3);
  padding: 0;
  font: var(--t-heading);
}

/* Vitals fill the width in the paper-chart order, left to right, then down. */
.vitalsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 14rem), 1fr));
  gap: var(--space-4) var(--space-5);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.heading {
  margin: 0;
  font: var(--t-heading);
}

.help {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.actions,
.inlineActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.draftStatus {
  color: var(--graphite);
  font: var(--t-small);
}

.actions .draftStatus:last-child {
  margin-left: auto;
}

.allergyList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.allergyState {
  margin: 0;
  font: var(--t-body-strong);
}

.allergyForm {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--rule);
  border-radius: var(--radius-control);
}

.summary {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.summary dt {
  color: var(--graphite);
}

.summary dd {
  margin: 0;
}

.vitalsTable {
  width: 100%;
  border-collapse: collapse;
}

.vitalsTable th,
.vitalsTable td {
  height: var(--row-height-dense);
  padding: 0 var(--space-2);
  border-bottom: 1px solid var(--rule);
  font: var(--t-body);
  text-align: left;
}

.vitalsTable th {
  color: var(--graphite);
  font-weight: 400;
}

.caption {
  padding-bottom: var(--space-2);
  color: var(--graphite);
  font: var(--t-small);
  text-align: left;
}

.value {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.value[data-abnormal] {
  font-weight: 600;
}

.value[data-critical] {
  color: var(--danger);
}

.superseded td,
.superseded th {
  color: var(--pencil);
  text-decoration: line-through;
}

.history {
  font: var(--t-small);
  color: var(--graphite);
}
